import StorageService from './../storage/StorageService';

export function currentUser(state = {}) {
    return {
      currentUser: (StorageService.getLogin()!==null)? StorageService.getLogin().profile.userType : null,
      name: (StorageService.getLogin()!==null)? StorageService.getLogin().profile.firstName + ' ' +  StorageService.getLogin().profile.lastName : null,
      id: (StorageService.getLogin()!==null)? StorageService.getLogin().profile.userId : null,
      status: (StorageService.getLogin()!==null)? StorageService.getLogin().profile.status : null,
    };    
}